/*!Copyright 2010 karmadata, Inc. **/
/**kd.api.data requires
* jQuery
* Underscore.js
* moment.js
*/
var Page = (function () {
    return function (startIn, rowsPerPageIn, resultCountIn) {
        /**The kd.api.data.Page handles Paging for a kd.api.data.Request (wraps all RequestItems like OrderBy)
        *The Order and Pagination lives here
        *The Action, Filters, Aggregations live in the kd.api.data.RequestItem
        *For convenience, we instantiate the initial RequestItem and add it to the requestList for Post body
        */
        //Private Variables 
        var start = 1;
        var rowsPerPage = 10;
        var resultCount;
        /**Calculated here on client side for convenience...BUT need to check server side validation too 
        * as server may reject client request for say start=11&rowsPerPage=1000 and thus a calculated End of 1010 
        * and may only give back start=11&rowsPerPage=5...and thus a real end of 15*/
        var paginationEnd; 

        //Private Functions
        var validateStart = function () {

            if (start <= 0) {
                if (resultCount <= 0) {
                    start = 0;
                } else {
                    start = 1;
                }
            }

            if (resultCount <= 0) {
                start = 0;
            }
        };

        var calculateStartPageUp = function () {
            start = start + rowsPerPage;
            validateStart();//This checks the validity

        };

        var calculateStartPageDown = function () {
            start = start - rowsPerPage;
            validateStart();//This checks the validity
        };

        var validateEnd = function () {

            if (paginationEnd > resultCount) {
                if (resultCount <= 0) {
                    paginationEnd = 0;
                } else {
                    paginationEnd = resultCount;
                }

            }
        };

        var calculateEnd = function () {
            paginationEnd = start + rowsPerPage - 1;
            validateEnd();

        };

        var init = function () {
            if (startIn) {
                start = startIn;
            } else {
                start = 1;
            }
            if (rowsPerPageIn) {
                rowsPerPage = rowsPerPageIn;
            } else {
                rowsPerPage = 10;
            }
            if (resultCountIn) {
                resultCount = resultCountIn;
            } else {
                resultCount = 0;
            }

            validateStart(); //This checks the validity
            calculateEnd(); //This checks the validity
        };

        //Public Variables
        this.IsPagination = true;


        //Privileged functions, can access both public and private
        //We need functions here to do protected get and set
        //and to do error checking and handling
        this.getPageStart = function () {
            return start;
        };
        this.setPageStart = function (startRow) {
            start = startRow;
            calculateEnd();
            return start;
        };
        this.getPageRows = function () {
            return rowsPerPage;
        };
        this.setPageRows = function (rows) {
            rowsPerPage = rows;
            calculateEnd();
        };
        this.getEnd = function () {
            return paginationEnd;
        };
        this.setResultCount = function (count) {
            resultCount = count;
            validateStart();
            calculateEnd();
        };
        this.getResultCount = function () {
            return resultCount;
        };
        this.getPageNumber = function () {
            var exact = start / rowsPerPage;
            var round = Math.round(start / rowsPerPage);
            if (round < exact) {
                return round + 1;
            } else {
                return round;
            }

        };
        this.pageUp = function () {
            calculateStartPageUp();
            calculateEnd();
        };
        this.pageDown = function () {
            calculateStartPageDown();
            calculateEnd();
        };

        this.reset = function () {
            init();
        };
        
        /**Bootstrap the closure*/
        init();
        
    };
})();


exports.Page = Page



//////////////////
// WEBPACK FOOTER
// ./~/karmadata/kd.api.data/kd.api.data.Page.js
// module id = 212
// module chunks = 0